(function ($) {
  Drupal.behaviors.tab_item_formatter_v1 = {
    attach: function (context, settings) {
      var $container = $('.tab_item_formatter_v1', context);
      var $sideBar = $('.sidebar-page__sidebar', $container);
      var $sideContent = $('.sidebar-page__content', $container);
      var init_tab = window.location.href.split('#')[1] || '';
      var $current_tab;

      $container.each(function (index, el) {
        var $wrapper = $('.tab_item_wrapper a.item', $(this));
        var $display_container = $('.display_container', $(this));

        $display_container.empty();
        $wrapper.each(function () {
          var $tab = $(this);
          var href = $tab.attr('href').replace('#', '');

          if (href === init_tab) {
            $current_tab = $tab;
          }
          $tab.on('click', function (e) {
            $wrapper.removeClass('active');
            $(this).addClass('active');
            $display_container.empty();
            $(this).parent().find('.row-item-wrapper').clone(true).show().appendTo($display_container);
            $sideBar.css('height', $sideContent.outerHeight() + 'px');
          });
        });

        $current_tab = $current_tab || $wrapper.first();
        $current_tab.trigger('click');
      });
    }
  };
})(jQuery);
